const ChatComposerSeparator = <template>
  <div class="chat-composer-separator"></div>
</template>;

export default ChatComposerSeparator;
